export function formatError(error: unknown): { message: string; details: string } {
  if (error instanceof Error) {
    const details = error.stack?.trim() || `${error.name}: ${error.message}`;
    return { message: error.message || "Something went wrong", details };
  }

  if (typeof error === "string") {
    return { message: error, details: error };
  }

  if (error && typeof error === "object") {
    const maybeMessage = (error as { message?: unknown }).message;
    if (typeof maybeMessage === "string" && maybeMessage.trim()) {
      try {
        return { message: maybeMessage, details: JSON.stringify(error, null, 2) };
      } catch {
        return { message: maybeMessage, details: maybeMessage };
      }
    }
  }

  try {
    const details = JSON.stringify(error, null, 2);
    return { message: "Something went wrong", details: details || String(error) };
  } catch {
    return { message: "Something went wrong", details: String(error) };
  }
}
